import { memo } from 'react';
import PropTypes from 'prop-types';

import { InsightIcon } from 'basic-components/icons';
import { DashboardLinkFactory } from 'ng-common-features/urlBuilder';

import './InsightRow.scss';

const InsightRow = ({ groupName, name, optional }) => (
  <a 
      className="search-all__content__results__recents__element__insight"
      href={DashboardLinkFactory.insight.view({ groupName, name })}
  >
    <div className="search-all__content__results__recents__element__insight__left">
      <InsightIcon
      />
    </div>
    <div className="search-all__content__results__recents__element__insight__right">
      <div className="search-all__content__results__recents__element__insight__right__top">
        {name}
      </div>
      <div className="search-all__content__results__recents__element__insight__right__bottom">
        {optional}
      </div>
    </div>
  </a>
)

InsightRow.propTypes = {
  groupName: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  optional: PropTypes.string.isRequired,
}

export default memo(InsightRow)
